var _path, _radialGradient, _path2, _linearGradient, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303c42",
    d: "M6.978 24A6.985 6.985 0 0 1 0 17.022V6.978A6.985 6.985 0 0 1 6.978 0h10.044A6.985 6.985 0 0 1 24 6.978v10.044A6.985 6.985 0 0 1 17.022 24H6.978zm0-20A2.981 2.981 0 0 0 4 6.978v10.044A2.981 2.981 0 0 0 6.978 20h10.044A2.981 2.981 0 0 0 20 17.022V6.978c0-.184-.017-.364-.049-.538a2.003 2.003 0 0 1-2.222 1.542A6.965 6.965 0 0 1 19 12c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.494 0 2.88.471 4.018 1.271a2.003 2.003 0 0 1 1.542-2.222A2.974 2.974 0 0 0 17.022 4H6.978zM12 9c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 3.708,
    cy: 20.917,
    r: 26.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#f79938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f73379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#b043a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#6854d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#3a5ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M17.022 1H6.978A5.985 5.985 0 0 0 1 6.978v10.044A5.985 5.985 0 0 0 6.978 23h10.044A5.985 5.985 0 0 0 23 17.022V6.978A5.985 5.985 0 0 0 17.022 1zM21 17.022A3.983 3.983 0 0 1 17.022 21H6.978A3.983 3.983 0 0 1 3 17.022V6.978A3.983 3.983 0 0 1 6.978 3h10.044A3.983 3.983 0 0 1 21 6.978v10.044zM12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm6-11c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.372,
    x2: 24.372,
    y1: 6.231,
    y2: 17.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M6.978 24A6.985 6.985 0 0 1 0 17.022V6.978A6.985 6.985 0 0 1 6.978 0h10.044A6.985 6.985 0 0 1 24 6.978v10.044A6.985 6.985 0 0 1 17.022 24H6.978zm0-20A2.981 2.981 0 0 0 4 6.978v10.044A2.981 2.981 0 0 0 6.978 20h10.044A2.981 2.981 0 0 0 20 17.022V6.978c0-.184-.017-.364-.049-.538a2.003 2.003 0 0 1-2.222 1.542A6.965 6.965 0 0 1 19 12c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.494 0 2.88.471 4.018 1.271a2.003 2.003 0 0 1 1.542-2.222A2.974 2.974 0 0 0 17.022 4H6.978zM12 9c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dba10b11966006afe92e14a792cca7e3.svg";
export { ForwardRef as ReactComponent };